import PostAnalyticsRequestModelBase from '../_generated/modelBases/post-analytics-request-model-base';

export default class PostAnalyticsRequestModel extends PostAnalyticsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
